import { EMAIL_TOKENS } from "./styles/tokens";

export interface EmailFont {
  label: string;
  /** CSS font-family for email HTML (real name + fallback) */
  value: string;
  category: "web-safe" | "google";
}

export const EMAIL_FONTS: EmailFont[] = [
  // Web-safe
  { label: "Arial", value: EMAIL_TOKENS.fontFamily.sans, category: "web-safe" },
  {
    label: "Verdana",
    value: "'Verdana', 'Geneva', sans-serif",
    category: "web-safe",
  },
  {
    label: "Tahoma",
    value: "'Tahoma', 'Geneva', sans-serif",
    category: "web-safe",
  },
  {
    label: "Trebuchet MS",
    value: "'Trebuchet MS', 'Helvetica', sans-serif",
    category: "web-safe",
  },
  {
    label: "Georgia",
    value: EMAIL_TOKENS.fontFamily.serif,
    category: "web-safe",
  },
  {
    label: "Times New Roman",
    value: "'Times New Roman', 'Times', serif",
    category: "web-safe",
  },
  {
    label: "Courier New",
    value: EMAIL_TOKENS.fontFamily.mono,
    category: "web-safe",
  },

  // Google Fonts — Sans-serif
  { label: "Inter", value: "'Inter', sans-serif", category: "google" },
  { label: "Roboto", value: "'Roboto', sans-serif", category: "google" },
  { label: "Open Sans", value: "'Open Sans', sans-serif", category: "google" },
  { label: "Lato", value: "'Lato', sans-serif", category: "google" },
  {
    label: "Montserrat",
    value: "'Montserrat', sans-serif",
    category: "google",
  },
  { label: "Poppins", value: "'Poppins', sans-serif", category: "google" },
  { label: "Nunito", value: "'Nunito', sans-serif", category: "google" },
  { label: "Raleway", value: "'Raleway', sans-serif", category: "google" },
  { label: "DM Sans", value: "'DM Sans', sans-serif", category: "google" },
  { label: "Work Sans", value: "'Work Sans', sans-serif", category: "google" },
  { label: "Outfit", value: "'Outfit', sans-serif", category: "google" },
  {
    label: "Plus Jakarta Sans",
    value: "'Plus Jakarta Sans', sans-serif",
    category: "google",
  },
  {
    label: "Source Sans 3",
    value: "'Source Sans 3', sans-serif",
    category: "google",
  },
  { label: "Cabin", value: "'Cabin', sans-serif", category: "google" },
  { label: "Karla", value: "'Karla', sans-serif", category: "google" },
  { label: "Rubik", value: "'Rubik', sans-serif", category: "google" },
  { label: "Quicksand", value: "'Quicksand', sans-serif", category: "google" },
  { label: "Mulish", value: "'Mulish', sans-serif", category: "google" },
  { label: "Manrope", value: "'Manrope', sans-serif", category: "google" },
  {
    label: "Space Grotesk",
    value: "'Space Grotesk', sans-serif",
    category: "google",
  },
  { label: "Sora", value: "'Sora', sans-serif", category: "google" },
  { label: "Geist", value: "'Geist', sans-serif", category: "web-safe" },

  // Google Fonts — Serif
  {
    label: "Playfair Display",
    value: "'Playfair Display', serif",
    category: "google",
  },
  { label: "Merriweather", value: "'Merriweather', serif", category: "google" },
  {
    label: "Libre Baskerville",
    value: "'Libre Baskerville', serif",
    category: "google",
  },
  { label: "Lora", value: "'Lora', serif", category: "google" },
  { label: "PT Serif", value: "'PT Serif', serif", category: "google" },
  {
    label: "Source Serif 4",
    value: "'Source Serif 4', serif",
    category: "google",
  },
  { label: "EB Garamond", value: "'EB Garamond', serif", category: "google" },
  { label: "Crimson Text", value: "'Crimson Text', serif", category: "google" },
  { label: "Bitter", value: "'Bitter', serif", category: "google" },
  { label: "Noto Serif", value: "'Noto Serif', serif", category: "google" },

  // Google Fonts — Display / Condensed
  { label: "Oswald", value: "'Oswald', sans-serif", category: "google" },
  {
    label: "Bebas Neue",
    value: "'Bebas Neue', sans-serif",
    category: "google",
  },
  { label: "Archivo", value: "'Archivo', sans-serif", category: "google" },
  { label: "Barlow", value: "'Barlow', sans-serif", category: "google" },
  {
    label: "Josefin Sans",
    value: "'Josefin Sans', sans-serif",
    category: "google",
  },

  // Google Fonts — Monospace
  {
    label: "Roboto Mono",
    value: "'Roboto Mono', monospace",
    category: "google",
  },
  {
    label: "Source Code Pro",
    value: "'Source Code Pro', monospace",
    category: "google",
  },
  {
    label: "JetBrains Mono",
    value: "'JetBrains Mono', monospace",
    category: "google",
  },
  { label: "Fira Code", value: "'Fira Code', monospace", category: "google" },
  { label: "Space Mono", value: "'Space Mono', monospace", category: "google" },
];

/**
 * Combined Google Fonts CDN URL. Loads CSS declarations for all Google Fonts;
 * actual woff2 files are fetched on demand only when a font is rendered.
 */
export const GOOGLE_FONTS_CDN_URL = `https://fonts.googleapis.com/css2?${EMAIL_FONTS.filter(
  (f) => f.category === "google",
)
  .map((f) => `family=${f.label.replace(/ /g, "+")}:wght@400;700`)
  .join("&")}&display=swap`;
